import { keyframes } from '@emotion/react';
import type { ThemeUIStyleObject } from 'theme-ui';

const animatePulse = keyframes`
  0% {
    opacity: 1;
  }
  60% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
`;

/**
 * @doc $DOC:pulse
 */
export function animatePulseStyles(durationMs = 2000): ThemeUIStyleObject {
	return {
		// templated string necessary here for @emotion to generate the keyframes CSS
		animationName: `${animatePulse}`,
		animationDuration: `${durationMs}ms`,
		animationIterationCount: 'infinite',
	};
}
